const React = require('react');
const { default: Styled } = require('styled-components');
const WaveAsset = require('static/nerpy-wave.gif');
const StillAsset = require('static/nerpy-wave-still.png');

const internals = {};

module.exports = function NerpyAvatar({ name = 'Nerpy', animated = false }) {

    const { Portrait } = internals;

    return <Portrait>
        <source media='(prefers-reduced-motion: reduce)' srcSet={StillAsset.default || StillAsset} />
        <img src={(animated ? WaveAsset : StillAsset).default || (animated ? WaveAsset : StillAsset)} alt={`${name}, companion`} width='48' height='48' />
    </Portrait>;
};

internals.Portrait = Styled.picture`
    display: inline-flex;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    vertical-align: middle;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
